export class SaasGroupProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasGroupProperties.attributeTypeMap;
    }
    constructor() {
    }
}
